(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6437],{

/***/ 6437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content008": function() { return /* binding */ Content008; },
  "default": function() { return /* binding */ Content008_Content008; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./src/components/widgets/content/Content008/Content008.module.scss
var Content008_module = __webpack_require__(34201);
var Content008_module_default = /*#__PURE__*/__webpack_require__.n(Content008_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/components/widgets/content/Content008/Item/Item.module.scss
var Item_module = __webpack_require__(72052);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/Item/Item.jsx




var Item = function(param) {
    var item = param.item;
    var title = item.title, subTitle = item.subTitle, location = item.location, media = item.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Item_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Item_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Item_module_default()).left,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading7 */.Pb, {
                            className: (Item_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (Item_module_default()).subtitle,
                            children: subTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (Item_module_default()).location,
                    children: location
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: media,
                    className: (Item_module_default()).background
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/Partners/Partners.jsx





var Partners = function(param) {
    var items = param.items;
    var ref = (0,Tabs_hooks/* useTabsState */.n)(), activeTab = ref.activeTab, isDefaultTab = ref.isDefaultTab;
    var filterPartners = (0,react.useMemo)(function() {
        if (isDefaultTab) {
            return items;
        }
        return items.filter(function(param) {
            var continent = param.continent;
            return continent.toLowerCase() === activeTab.toLowerCase();
        });
    }, [
        isDefaultTab,
        activeTab,
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content008_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Content008_module_default()).items,
            children: filterPartners.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    item: item
                }, item.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/Partners/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/Content008.jsx







var Content008 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var partners = (ref2 = payload === null || payload === void 0 ? void 0 : payload.partners) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var appearance = (ref3 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref3 !== void 0 ? ref3 : "light";
    var extractedTabs = (0,_to_consumable_array/* default */.Z)(new Set(partners.map(function(item) {
        return item.continent;
    })));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Content008_module_default()).wrapper, (Content008_module_default())[appearance]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (Content008_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content008_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading2 */.XJ, {
                            className: (Content008_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (Content008_module_default()).description,
                            color: "grey",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
                    items: extractedTabs,
                    defaultTab: true,
                    tabsEnabled: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {
                            appearance: "justify"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners, {
                            items: partners
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Content008_Content008 = (Content008);


/***/ }),

/***/ 34201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content008_wrapper__GmQgq","light":"Content008_light__cOHSY","grey":"Content008_grey__GBxzB","header":"Content008_header__B_oI_","title":"Content008_title__bIZX8","description":"Content008_description__Qq8eC","content":"Content008_content__dTzpI","items":"Content008_items__VMD0S"};

/***/ }),

/***/ 72052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__gh3fo","wrapper":"Item_wrapper__T73SH","background":"Item_background__rA1gV","title":"Item_title__N8B_c","subtitle":"Item_subtitle__s62WL","left":"Item_left__Wds98","location":"Item_location__UY3J9"};

/***/ })

}]);